import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './index.css';
import { Toaster } from 'react-hot-toast';
import { installTerminalDataCapture } from './utils/taraTerminalContext';

// Lets Tara answer questions about whatever the Suspire Terminal has loaded.
installTerminalDataCapture();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      <Toaster position="top-right" toastOptions={{ style: { fontFamily: 'Inter, sans-serif', fontSize: 15 } }} />
    </Provider>
  </React.StrictMode>
);
